<template>
  <div class="packageTicket-book mt40">
    <!-- 填写订单信息 -->
    <div class="order-info">
      <div class="title">填写订单信息</div>
      <div class="subTitle">{{ `${packageTicketInfo.packageTicketName}（${packageTicketInfo.viewPointName}）` }}</div>
      <!-- 预订信息 出游日期-->
      <div class="order-info-item">
        <div class=" item-hd flex-start ">
          <img src="../../assets/imgs/package-ticket-date-icon.png" alt="">
          <span class=" order-info-item-span">请选择出游日期</span>
        </div>
        <div class="item-bd ">
          <div class="date-div flex-space-between">
            <div v-for="(item, index) in initDateArr" :key="index" class="num-div-item date-item-style" :class="{ active: index ===useStartDateIndex}" @click="handleClickDateDiv(index)">
              {{ dealDateWeek(item) }}
              <img v-if="index=== useStartDateIndex" src="../../assets/images/selected-icon.png" alt="">
            </div>
            <div class="num-div-item other date-item-style" @click="handleShowDate('startDate')">
              {{ useStartDateIndex===3?dealDateWeek(orderInfo.useStartDate):"其他日期" }}
              <el-date-picker
                ref="startDate"
                v-model="orderInfo.useStartDate"
                class="hide-date"
                popper-class="start-date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                :picker-options="setStartDateDisabled"
                @change="handleStartDate"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 预订信息 选择数量-->
      <div class="order-info-item">
        <div class=" item-hd flex-start ">
          <img src="../../assets/imgs/package-ticket-icon.png" alt="">
          <span class=" order-info-item-span">请选择数量</span>
        </div>
        <div class="item-bd ">
          <div class="date-div flex-space-between">
            <div v-for="(item, index) in 6" :key="index" class="num-div-item num-item-style" :class="{ active: index+1 === orderInfo.quantity && !edit }" @click="handleRoomNum(index+1)">
              {{ index+1 }}
              <img v-if="index+1 === orderInfo.quantity && !edit" src="../../assets/images/selected-icon.png" alt="">
            </div>
            <div class="num-div-item other  num-item-style">
              <span v-if="!edit" @click="handleEdit">其他</span>
              <el-input v-else ref="othernum" v-model="orderInfo.quantity" min="1" maxlength="4" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" @blur="handleBlur" />
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="playTime">
        出游时间：{{ orderInfo.useStartDate }}
      </div> -->
      <!--门票-->
      <el-form ref="form" :model="orderCreatInfoObj"  label-width="0">
        <div v-for="(orderCreatInfo,idx) in orderCreatInfoObj.orderCreatInfoList" :key="idx">
          <span class="ticketsort">套票{{idx+1}}</span>
          <div v-for="(trip,index) in orderCreatInfo.orderTripCreateList" :key="index">
            <div class="visitorMsg">
              <el-table :row-style="{background:'none'}" :header-cell-style="{background:'#9B232A'}" class="order-table" :default-expand-all="true" :data="trip.visitorList">
                <el-table-column align="center" label="景点名称">
                  <template>
                    <span>{{ trip.subGoodsName }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="产品名称">
                  <template>
                    <span>{{ trip.subGoodsTargetName }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="单价" :width="(trip.optionCode === 'A_VISITOR' || trip.optionCode === 'ALL_VISITOR')&&'80px'">
                  <template>
                    <span>¥{{ trip.subGoodsTargetSalePrice }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="数量" :width="(trip.optionCode === 'A_VISITOR' || trip.optionCode === 'ALL_VISITOR')&&'60px'">
                  <template>
                    <span>1</span>
                  </template>
                </el-table-column>
                <template v-if="trip.optionCode === 'A_VISITOR' || trip.optionCode === 'ALL_VISITOR'">
                  <el-table-column align="center" label="姓名">
                    <template slot-scope="scope">
                      <el-form-item :prop="'orderCreatInfoList.'+ idx +'.orderTripCreateList.' + index +  '.visitorList.' + scope.$index + '.visitorName'" :rules="trip.optionCode === 'ALL_VISITOR'?[{ required: true, message: '请输入姓名'}] : []">
                        <el-input v-model="scope.row.visitorName" placeholder="请输入姓名" />
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="证件类型">
                    <template slot-scope="scope">
                      <el-form-item :prop="'orderCreatInfoList.' + idx + '.orderTripCreateList.' + index + '.visitorList.' + scope.$index + '.visitorCertificateType'" :rules="trip.optionCode === 'ALL_VISITOR'?[{ required: true, message: '请选择证件类型'}]:[]">
                        <el-select
                          v-model="scope.row.visitorCertificateType"
                          style="display:block"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="i in certificateTypes"
                            :key="i.code"
                            :label="i.value"
                            :value="i.code"
                          />
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="证件号" width="200">
                    <template slot-scope="scope">
                      <el-form-item :prop="'orderCreatInfoList.'+ idx + '.orderTripCreateList.' + index + '.visitorList.' + scope.$index + '.visitorCertificateNo'" :rules="trip.optionCode === 'ALL_VISITOR'?[{ required: true, message: '请输入证件号'}]:[]">
                        <el-input v-model="scope.row.visitorCertificateNo" placeholder="请输入证件号" />
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="200px">
                    <template slot-scope="scope">
                      <el-button style="background: #869ECD;color: #FFFFFF;" @click="resetItem('orderTripCreateList',index, scope.$index)">重置</el-button>
                    </template>
                  </el-table-column>
                </template>
              </el-table>

            </div>
          </div>
          <!-- 酒店 -->
          <div v-for="(item,index) in orderCreatInfo.orderHotelCreateList" :key="'hotel-' + index">
            <div class="visitorMsg">
              <el-table :row-style="{background:'none'}" :header-cell-style="{background:'#9B232A'}" class="order-table" :default-expand-all="true" :data="item.visitorList">
                <el-table-column align="center" label="酒店名称">
                  <template>
                    <span>{{ item.subGoodsName }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="房型名称">
                  <template>
                    <span>{{ item.subGoodsTargetName }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="单价">
                  <template>
                    <span>¥{{ item.subGoodsTargetSalePrice }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="天数">
                  <template>
                    <span>{{ item.subGoodsTargetQuantity }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="离店时间">
                  <template>
                    <span>{{ leaveDate(orderInfo.useStartDate,item.subGoodsTargetQuantity) }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="入住人姓名">
                  <template slot-scope="scope">
                    <el-form-item :prop="'orderCreatInfoList.'+ idx +'.orderHotelCreateList.' + index + '.visitorList.' + scope.$index + '.visitorName'" :rules="[{ required: true, message: '请输入姓名'}]">
                      <el-input v-model="scope.row.visitorName" placeholder="请输入姓名" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="200px">
                  <template slot-scope="scope">
                    <el-button style="background: #869ECD;color: #FFFFFF;" @click="resetItem('orderHotelCreateList',index, scope.$index)">重置</el-button>
                  </template>
                </el-table-column>
              </el-table>

            </div>
          </div>
         </div>
      </el-form>
      <div class="packageIncludes">
        <div class="title mt40">
          套餐包含
        </div>
        <div class="includes-body">
          <div v-for="(item ,index) in orderCreatInfo.orderTripCreateList " :key="index">
            <div class="sub-title-line flex-start">
              <img src="../../assets/imgs/box.png" alt="">
              <span class="sub-title">{{ item.subGoodsName }} ({{ item.subGoodsTargetName }})</span>
            </div>
            <div class="sub-Goods">
              数量：{{ orderCreatInfoObj.orderCreatInfoList.length*item.visitorList.length }}张  <span class="ml40"> 参观时间：{{ orderInfo.useStartDate }}</span>
            </div>
          </div>
          <div v-for="(item ,index) in orderCreatInfo.orderHotelCreateList " :key="'hotel-' + index">
            <div class="sub-title-line flex-start">
              <img src="../../assets/imgs/box.png" alt="">
              <span class="sub-title">{{ item.subGoodsName }} ({{ item.subGoodsTargetName }})</span>
            </div>
            <div class="sub-Goods">
              {{  checkOutTime(orderInfo.useStartDate) }}  入住  <span class="ml40"> {{checkOutTime(orderInfo.useStartDate,item.subGoodsTargetQuantity) }} 退房</span><span class="ml40"> 共{{ orderCreatInfoObj.orderCreatInfoList.length }}晚</span>
            </div>
          </div>

        </div>
      </div>
      <!--  -->
      <el-form ref="contactForm" :model="contactFormData" label-width="120px">
        <div class="visitorMsg mt40">
          <div class="headline">
            联系人信息
            <span class="sub">(请准确填写，以免无法接收订单信息)</span>
          </div>
          <div class="msgForm">
            <el-form-item label="联系人手机号" :prop="`contactMobile`" :rules="[{required: true, validator: validateMobile, trigger: ['change', 'blur']}]">
              <el-input v-model="contactFormData.contactMobile" placeholder="请输入联系人手机号码" style="width:340px" />
            </el-form-item>
            <el-form-item v-if="needContactCardNo" label="身份证号" prop="contactCardNo" class="mt20" :rules="[{required: true, validator: validateCert, trigger: ['change', 'blur']}]">
              <el-input v-model="contactFormData.contactCardNo" placeholder="请输入联系人身份证号" style="width:340px" />
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- 总价 -->
      <div class="buy-div">
        <span class="font12 mr10">数量</span>
        <span>共</span>
        <span style="color:#9C242B">{{ orderInfo.quantity }}</span>
        <span>张</span>
        <span class="ml40 font12 mr10">总价</span>
        <span class="price">¥{{ totalAmount.toFixed(2) }}</span>
        <div v-loading.fullscreen.lock="fullscreenLoading" class="buy-btn" @click="handleBuy">立即购买</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/common/js/utils.js'
import { loadPriceCalendar, saveOrder, loadSubGoods } from '@/api/packageTicket/packageTicketBook'
import { cardtypeList } from '@/api/buyTicket'
import { config } from '@/constant/config'
export default {
  name: 'PackageTicketBook',
  data () {
    return {
      hadStock: false,
      certificateTypes: [],
      orderCreatInfo: { orderTripCreateList: [], orderHotelCreateList: [] },
      hasIdCard: false,
      contactFormData: {},
      needContactCardNo: false, // 是否需要联系人身份证
      useStartDate: formatDate('yyyy-MM-dd', new Date()),
      useStartDateIndex: 0,
      initDateArr: [formatDate('yyyy-MM-dd', new Date()), formatDate('yyyy-MM-dd', new Date(new Date().getTime() + 86400 * 1000)), formatDate('yyyy-MM-dd', new Date(new Date().getTime() + 86400 * 1000 * 2))],
      packageTicketInfo: {},
      roomInfo: {},
      orderInfo: {
        useStartDate: formatDate('yyyy-MM-dd', new Date()),
        useEndDate: formatDate('yyyy-MM-dd', new Date(new Date().getTime() + 86400 * 1000 * 2)),
        quantity: 1,
        guestList: [{ name: '' }],
        contactMobile: null
      },
      startMonth: formatDate('yyyy-MM-dd', new Date()),
      endMonth: formatDate('yyyy-MM-dd', new Date(new Date().getTime() + 86400 * 1000)),
      startDiasbledDateArr: [],
      endDiasbledDateArr: [],
      stayDays: 1,
      startWeek: null,
      endWeek: null,
      edit: false,
      showDetail: false,
      showPriceArr: [],
      bedTypeList: [],
      totalAmount: 0,
      disabledDateMin: null,
      disabledDateMax: null,
      moduleType: 'HOTEL',
      fullscreenLoading: false,
      orderCreatInfoObj: {
        orderCreatInfoList: []
      }
    }
  },
  computed: {
    // 入住日期禁用
    setStartDateDisabled () {
      const that = this
      return {
        disabledDate (time) {
          if (time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000 || time.getTime() < new Date(that.disabledDateMin).getTime() - 24 * 60 * 60 * 1000 || that.startDiasbledDateArr.indexOf(formatDate('yyyy-MM-dd', new Date(time))) !== -1) {
            return true
          }
        }
      }
    }
  },
  created () {
    this.packageTicketInfo = JSON.parse(this.$route.query.packageTicketInfo)
    this.packageTicketId = this.$route.query.packageTicketId
    this.cardtypeList() // 获取证件类型
    this.loadSubGoods(this.packageTicketId)
    this.$nextTick(() => {
      this.loadPriceCalendar(this.orderInfo.useStartDate, this.orderInfo.useEndDate, 'stockJudge')
    })
  },
  methods: {
    checkOutTime (date, days = 0) {
      let newDate = formatDate('yyyy-MM-dd', new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000 * days))
      let week = this.getWeekday(new Date(newDate).getDay())
      return newDate.replace('-', '年').replace('-', '月') + '日  ' + week.replace('星期', '周') + '  '
    },
    leaveDate (date, days) {
      return formatDate('yyyy-MM-dd', new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000 * days))
    },
    resetItem (name, i, j) {
      this.orderCreatInfo[name][i].visitorList[j] = {
        visitorName: null,
        visitorCertificateType: this.hasIdCard ? '1' : '',
        visitorCertificateNo: null
      }
      this.orderCreatInfo[name][i].visitorList.push({})
      this.orderCreatInfo[name][i].visitorList.pop()
    },
    // 验证身份证
    validateCert (rule, value, callback) {
      if ((value == null || value === '') && this.needContactCardNo) {
        callback(new Error('请输入联系人身份证号'))
      } else {
        if (value && !this.validaIDCardNo(value)) {
          callback(new Error('联系人身份证号格式不正确'))
        }
      }
      callback()
    },
    cardtypeList () {
      cardtypeList().then(res => {
        if (res.code === 0) {
          this.certificateTypes = res.data
          this.hasIdCard = !!this.certificateTypes.find(val => val.code === '1')
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          console.error(res.error)
        }
      })
    },

    // 子产品
    loadSubGoods (id) {
      loadSubGoods(id).then(res => {
        if (res.code === 0) {
          const orderTripCreateList = []
          const orderHotelCreateList = []
          res.data.forEach(val => {
            const obj = {
              subGoodsTargetId: val.subGoodsTargetId,
              subModuleType: val.subModuleType,
              subGoodsId: val.subGoodsId,
              subGoodsName: val.subGoodsName,
              subGoodsTargetName: val.subGoodsTargetName,
              subGoodsTargetQuantity: val.subGoodsTargetQuantity,
              subGoodsTargetSalePrice: val.subGoodsTargetSalePrice,
              visitorList: []

            }
            if (val.subModuleType === 'TRIP') {
              val.ruleInfoOptionList && val.ruleInfoOptionList.map(rule => {
                // 实名制票初始化出游人信息
                if (rule.ruleCode === 'REAL_NAME') {
                  if (rule.optionCode === 'ALL_VISITOR' || rule.optionCode === 'A_VISITOR') {
                    // 实名
                    obj.optionCode = rule.optionCode
                  } else if (rule.optionCode === 'TICKET_HOLDER') {
                    // 只需取票人身份信息
                    this.needContactCardNo = true
                  }
                }
              })
              for (let i = 0; i < obj.subGoodsTargetQuantity; i++) {
                obj.visitorList.push({
                  visitorName: null,
                  visitorCertificateType: this.hasIdCard ? '1' : '',
                  visitorCertificateNo: null
                })
              }
              obj.ruleInfoOptionList = val.ruleInfoOptionList
              orderTripCreateList.push(obj)
            } else if (val.subModuleType === 'HOTEL') {
              obj.visitorList = [{
                visitorName: null
              }]
              obj.goodsPicture = JSON.parse(val.subGoodsPicture)
              obj.maximumCapacity = val.maximumCapacity
              obj.startDate = this.startDate
              obj.startDateShow = this.startDateShow
              obj.startDateNickName = this.startDateNickName
              obj.days = this.days
              obj.endDate = this.endDate
              obj.endDateShow = this.endDateShow
              obj.endDateNickName = this.endDateNickName
              orderHotelCreateList.push(obj)
            }
          })
          this.orderCreatInfo = {
            orderTripCreateList,
            orderHotelCreateList
          }
          this.orderCreatInfoObj.orderCreatInfoList.push(this.orderCreatInfo)
          this.calAmount()
        }
      })
    },
    chunkArr (arr, size) {
      // 判断如果不是数组(就没有length)，或者size没有传值，size小于1，就返回空数组
      if (!arr.length || !size || size < 1) return []
      let [start, end, result] = [null, null, []]
      for (let i = 0; i < Math.ceil(arr.length / size); i++) {
        start = i * size
        end = start + size
        result.push(arr.slice(start, end))
      }
      return result
    },
    // 订单数据整理
    orderInfoData () {
      const orderData = {
        ...this.contactFormData,
        merchId: config.MERCHID,
        goodsId: this.packageTicketId,
        useStartDate: this.orderInfo.useStartDate
      }
      // 填写联系人身份证
      if (this.needContactCardNo) {
        orderData.contactCardType = '1'
      }
      const orderCreateItemList = []
      for (let i = 0; i < this.orderInfo.quantity; i++) {
        const orderCreateItem = {}
        // 门票订单信息
        if (this.orderCreatInfoObj.orderCreatInfoList.length > 0) {
          orderCreateItem.orderTripCreateList = []
          orderCreateItem.orderHotelCreateList = []
          const orderCreatInfo = this.orderCreatInfoObj.orderCreatInfoList[i]
          // 门票信息
          orderCreatInfo.orderTripCreateList.forEach(trip => {
            const chunkVisitorList = this.chunkArr(trip.visitorList, trip.subGoodsTargetQuantity)
            const tripObj = {
              goodsId: trip.subGoodsTargetId,
              intervalStockCalenderId: null,
              useStartDate: this.orderInfo.useStartDate,
              visitorList: []
            }
            if (trip.optionCode === 'ALL_VISITOR' || trip.optionCode === 'A_VISITOR') {
              const { visitorName, visitorCertificateType, visitorCertificateNo } = trip.visitorList[0]
              if (visitorName && visitorCertificateType && visitorCertificateNo) {
                tripObj.visitorList = chunkVisitorList[0]
              }
            }
            orderCreateItem.orderTripCreateList.push(tripObj)
          })
          // 酒店信息
          orderCreatInfo.orderHotelCreateList.forEach(room => {
            const roomObj = {
              goodsId: room.subGoodsTargetId,
              occupancyQuantity: 1,
              occupants: room.visitorList[0].visitorName,
              quantity: room.subGoodsTargetQuantity,
              useEndDate: this.leaveDate(this.orderInfo.useStartDate, room.subGoodsTargetQuantity),
              useStartDate: this.orderInfo.useStartDate
            }
            orderCreateItem.orderHotelCreateList.push(roomObj)
          })
        }
        // if (this.orderCreatInfo.orderTripCreateList.length > 0) {
        //   orderCreateItem.orderTripCreateList = []
        //   this.orderCreatInfo.orderTripCreateList.forEach(trip => {
        //     const chunkVisitorList = this.chunkArr(trip.visitorList, trip.subGoodsTargetQuantity)
        //     const tripObj = {
        //       goodsId: trip.subGoodsTargetId,
        //       intervalStockCalenderId: null,
        //       useStartDate: this.orderInfo.useStartDate,
        //       visitorList: []
        //     }
        //     if (trip.optionCode === 'ALL_VISITOR' || trip.optionCode === 'A_VISITOR') {
        //       const { visitorName, visitorCertificateType, visitorCertificateNo } = trip.visitorList[i]
        //       if (visitorName && visitorCertificateType && visitorCertificateNo) {
        //         tripObj.visitorList = chunkVisitorList[i]
        //       }
        //     }
        //     orderCreateItem.orderTripCreateList.push(tripObj)
        //   })
        // }
        // // 酒店订单信息
        // if (this.orderCreatInfo.orderHotelCreateList.length > 0) {
        //   orderCreateItem.orderHotelCreateList = []
        //   this.orderCreatInfo.orderHotelCreateList.forEach(room => {
        //     const roomObj = {
        //       goodsId: room.subGoodsTargetId,
        //       occupancyQuantity: 1,
        //       occupants: room.visitorList[i].visitorName,
        //       quantity: room.subGoodsTargetQuantity,
        //       useEndDate: this.leaveDate(this.orderInfo.useStartDate, room.subGoodsTargetQuantity),
        //       useStartDate: this.orderInfo.useStartDate
        //     }
        //     orderCreateItem.orderHotelCreateList.push(roomObj)
        //   })
        // }
        orderCreateItemList.push(orderCreateItem)
      }
      orderData.orderCreateItemList = orderCreateItemList
      return orderData
    },
    handleClickDateDiv (index) {
      this.useStartDateIndex = index
      this.$set(this.orderInfo, 'useStartDate', formatDate('yyyy-MM-dd', new Date(new Date().getTime() + 86400 * 1000 * index)))
    },
    dealDateWeek (val) {
      const week = this.getWeekday(new Date(val).getDay())
      return formatDate('MM-dd', new Date(val)).replace('-', '月') + '日-' + week
    },
    dealDate () {
    },
    validateMobile (rule, value, callback) {
      if (value == null || value === '') {
        callback(new Error('请输入联系人手机号'))
      } else {
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!reg.test(value)) {
          callback(new Error('联系人手机号格式不正确'))
        }
      }
      callback()
    },
    validateGuestList (rule, value, callback) {
      const nameArr = this.orderInfo.guestList.filter(val => val.name !== '')
      if (nameArr.length < this.orderInfo.guestList.length) {
        callback(new Error('请将入住信息填写完整'))
      }
      callback()
    },

    // 支付前验证
    validateInfo () {
      let j = 0
      try {
        this.orderCreatInfoObj.orderCreatInfoList.forEach((orderCreatInfo, idx) => {
          orderCreatInfo.orderTripCreateList.forEach((val, index) => {
            const visitorList = val.visitorList.filter(item => item.visitorName && item.visitorCertificateType && item.visitorCertificateNo)
            if (val.optionCode === 'A_VISITOR') {
              if (visitorList.length === 0) {
                j = j + 1
                throw new Error(`【${val.subGoodsName} ${val.subGoodsTargetName}】至少完善一位游客信息`)
              }
              val.visitorList.forEach((v, i) => {
                if ((v.visitorName && !v.visitorCertificateNo) || (!v.visitorName && v.visitorCertificateNo)) {
                  j = j + 1
                  throw new Error(`请将【${val.subGoodsName} ${val.subGoodsTargetName}】第${idx + 1}个游客信息填写完整`)
                } else if (v.visitorCertificateNo && v.visitorCertificateType === '1' && !this.validaIDCardNo(v.visitorCertificateNo)) {
                  j = j + 1
                  throw new Error(`【${val.subGoodsName} ${val.subGoodsTargetName}】第${idx + 1}个游客的身份证号码有误1`)
                }
              })
            } else if (val.optionCode === 'ALL_VISITOR') {
              // if (this.orderCreatInfoObj.orderCreatInfoList.length !== this.orderInfo.quantity * val.subGoodsTargetQuantity) {
              //   j = j + 1
              //   throw new Error(`请将【${val.subGoodsName} ${val.subGoodsTargetName}】的游客信息填写完整`)
              // }
              val.visitorList.forEach((v, i) => {
                if (v.visitorCertificateNo && v.visitorCertificateType === '1' && !this.validaIDCardNo(v.visitorCertificateNo)) {
                  j = j + 1
                  throw new Error(`【${val.subGoodsName} ${val.subGoodsTargetName}】第${idx + 1}个游客的身份证号码有误12`)
                }
              })
            }
          })
        })
      } catch (e) {
        this.$message.warning(e.message)
        throw e
      }
      if (j > 0) {
        return false
      }
      return true
    },

    handleBuy () {
      const quantity = this.orderInfo.quantity
      if (quantity == null || quantity === '' || quantity < 1) {
        this.$message.warning('数量需大于0')
        return
      }
      // 联系人信息
      let contactFormValid = false
      this.$refs.contactForm.validate(valid => {
        if (valid) {
          contactFormValid = true
        }
      })
      this.$refs.form.validate(valid => {
        if (valid && contactFormValid) {
          if (!this.hadStock) {
            this.$message.warning('当前日期库存不足')
            return
          }
          if (!this.validateInfo()) {
            return
          }
          const orderData = this.orderInfoData()
          this.fullscreenLoading = true

          saveOrder(orderData).then(res => {
            if (res.code === 0) {
              this.orderNo = res.data
              const orderCreatInfo = {
                ...this.orderCreatInfo,
                quantity: this.orderCreatInfoObj.orderCreatInfoList.length,
                useStartDate: this.orderInfo.useStartDate
              }
              localStorage.setItem('orderCreatInfo', JSON.stringify(orderCreatInfo))
              this.$router.push({
                path: '/payOrderPackageTicket',
                query: {
                  orderNo: res.data
                }
              })
            } else {
              this.fullscreenLoading = false
              this.$message.error(res.error)
            }
          })
        }
      })
    },
    //  获取价格日历 ， 根据salePrice判断是否有库存，
    loadPriceCalendar (useDateStart, useDateEnd, stockJudge) {
      const data = {
        goodsId: this.packageTicketId,
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        useDateStart,
        useDateEnd,
        customerType: 'SANKE'
      }
      this.startDiasbledDateArr = []
      this.endDiasbledDateArr = []
      loadPriceCalendar(data).then(res => {
        if (res.code === 0) {
          if (res.data && res.data.length > 0) {
            res.data.forEach((obj, index) => {
              if (obj.salePrice == null || obj.salePrice === '') {
                this.startDiasbledDateArr.push(obj.useDate)
              }
            })
            this.stockDateArr = res.data
          }
          if (stockJudge === 'stockJudge') {
            this.stockJudge(useDateStart, useDateEnd)
          }
        } else {
          this.$message.error(res.error)
        }
        if (this.startDateLoading) {
          this.startDateLoading.close()
        }
        if (this.endDateLoading) {
          this.endDateLoading.close()
        }
      })
    },
    stockJudge (startDate, endDate) {
      if (this.startDiasbledDateArr.includes(startDate)) {
        this.hadStock = false
        this.$message.warning('库存不足无法下单，请重新选择日期')
      } else {
        this.hadStock = true
      }
      this.calAmount()
    },
    // 价格合算
    calAmount () {
      this.totalAmount = this.packageTicketInfo.salePrice * this.orderInfo.quantity
    },
    // 床型处理
    bedShapeInformationDeal (data) {
      data = JSON.parse(data)
      let bedShapeInformation = ''
      data.forEach(val => {
        const obj = this.bedTypeList.find(v => v.code === val.bedType)
        bedShapeInformation = `${bedShapeInformation},${val.bedNum}张${obj.value}`
      })
      bedShapeInformation = bedShapeInformation.substring(1)
      return bedShapeInformation
    },
    // 设施处理
    relatedFacilitiesDeal (data) {
      data = JSON.parse(data)
      const relatedFacilities = data.map(val => {
        val.valueStr = ''
        val.value.forEach(v => {
          val.valueStr = `${val.valueStr}、${v.name}`
        })
        val.valueStr = val.valueStr.substring(1)
        return val
      })
      return relatedFacilities
    },
    handleShowDetail () {
      this.showDetail = !this.showDetail
    },
    // 点击其他  房间数量
    handleEdit () {
      this.edit = true
      this.$set(this.orderInfo, 'quantity', null)
      this.$nextTick(() => {
        this.$refs.othernum.focus()
      })
    },
    handleBlur () {
      const quantity = this.orderInfo.quantity
      if (quantity == null || quantity === '' || quantity < 1) {
        this.$message.warning('数量需大于0')
        return
      }
      this.dealGuestList()
    },
    // 选择房间数量
    handleRoomNum (quantity) {
      this.edit = false
      this.$set(this.orderInfo, 'quantity', quantity)
      this.dealGuestList()
    },
    // 住客数组处理
    dealGuestList () {
      const quantity = this.orderInfo.quantity
      const orderLength = this.orderCreatInfoObj.orderCreatInfoList.length
      const orderCreatInfoList = this.orderCreatInfoObj.orderCreatInfoList
      if (quantity - orderLength > 0) {
        const obj = JSON.parse(JSON.stringify(orderCreatInfoList[0]))
        for (let i = 0; i < quantity - orderLength; i++) {
          orderCreatInfoList.push(obj)
        }
        this.orderCreatInfoObj.orderCreatInfoList = orderCreatInfoList.concat([])
      } else if (quantity - orderLength < 0) {
        const tmparr = orderCreatInfoList.slice(0, quantity)
        this.orderCreatInfoObj.orderCreatInfoList = tmparr.concat([])
      }
      console.log('2', this.orderCreatInfoObj)
      // const orderCreatInfo = JSON.parse(JSON.stringify(this.orderCreatInfo))
      // orderCreatInfo.orderTripCreateList.map((item) => {
      //   for (let i = 0; i < quantity * item.subGoodsTargetQuantity; i++) {
      //     if (item.visitorList[i] === undefined) {
      //       item.visitorList.push({
      //         visitorName: null,
      //         visitorCertificateType: this.hasIdCard ? '1' : '',
      //         visitorCertificateNo: null
      //       })
      //     }
      //   }
      //   item.visitorList.length = quantity * item.subGoodsTargetQuantity
      // })

      // orderCreatInfo.orderHotelCreateList.map((item) => {
      //   for (let i = 0; i < quantity; i++) {
      //     if (!item.visitorList[i]) {
      //       item.visitorList.push({ visitorName: null })
      //     }
      //   }
      //   item.visitorList.length = quantity
      // })
      // this.orderCreatInfo = { ...orderCreatInfo }
      console.log('1111', this.orderCreatInfoObj.orderCreatInfoList)
      this.calAmount()
    },
    validaIDCardNo (str) {
      const reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
      return reg.test(str)
    },
    // 选择入住日期
    handleStartDate (date) {
      this.useStartDateIndex = 3
      this.startMonth = formatDate('yyyy-MM-dd', new Date(this.orderInfo.useStartDate))
      this.loadPriceCalendar(this.startMonth, this.orderInfo.useEndDate, 'stockJudge')
    },
    getWeekday (day) {
      return ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][day]
    },
    // 获取两个日期相差天数
    getDaysBetween (start, end) {
      const startDate = Date.parse(start)
      const endDate = Date.parse(end)
      return (endDate - startDate) / (86400 * 1000)
    },
    // 获取两个日期之间的日期
    getBetweenDateStr (stime, etime) {
    // 初始化日期列表，数组
      var diffdate = []
      var i = 0
      // 开始日期小于等于结束日期,并循环
      while (stime <= etime) {
        diffdate[i] = stime
        // 获取开始日期时间戳
        var stimeTs = new Date(stime).getTime()
        // 增加一天时间戳后的日期
        var nextDate = stimeTs + (24 * 60 * 60 * 1000)
        // 拼接年月日，这里的月份会返回（0-11），所以要+1
        var nextDatesY = new Date(nextDate).getFullYear() + '-'
        var nextDatesM = (new Date(nextDate).getMonth() + 1 < 10) ? '0' + (new Date(nextDate).getMonth() + 1) + '-' : (new Date(nextDate).getMonth() + 1) + '-'
        var nextDatesD = (new Date(nextDate).getDate() < 10) ? '0' + new Date(nextDate).getDate() : new Date(nextDate).getDate()

        stime = nextDatesY + nextDatesM + nextDatesD

        // 增加数组key
        i++
      }
      return diffdate
    },
    handleShowDate (date) {
      // this.useStartDateIndex=index
      this.dateType = date
      this.$refs[date].focus()
      // 加载当前月的库存
      const nowDate = date === 'startDate' ? this.startMonth : this.endMonth
      this.getDateToLoadPriceCalendar(nowDate)
      // 监听切换月份键
      if (!this.listenStart && date === 'startDate') {
        this.listenStartMonth()
        this.listenStart = true
      }
    },
    getDateToLoadPriceCalendar (nowDate) {
      this.$nextTick(() => {
        if (this.dateType === 'startDate') {
          this.startDateLoading = this.$loading({
            lock: true,
            text: '请稍等',
            backgroundColor: 'rgba(55,55,55,0.4)',
            spinner: 'el-icon-loading',
            target: document.querySelector('.start-date .el-picker-panel__content')
          })
        } else {
          this.endDateLoading = this.$loading({
            lock: true,
            text: '请稍等',
            backgroundColor: 'rgba(55,55,55,0.4)',
            spinner: 'el-icon-loading',
            target: document.querySelector('.end-date .el-picker-panel__content')
          })
        }
      })
      const dateObj = this.getDateByMonth(new Date(nowDate).getTime())
      // 如果是当前月则startDate为当天
      const nowMonth = new Date().getMonth() + 1 // 当前月
      if (parseInt(nowMonth) === parseInt(formatDate('MM', new Date(nowDate)))) {
        dateObj.startDate = formatDate('yyyy-MM-dd', new Date())
      }
      this.disabledDateMin = dateObj.startDate
      this.disabledDateMax = dateObj.endDate
      this.loadPriceCalendar(dateObj.startDate, dateObj.endDate)
    },
    // 获取某月第一天和最后一天
    getDateByMonth (timeStamp) {
      const inDate = new Date(timeStamp)
      const year = inDate.getFullYear()
      const month = inDate.getMonth()
      const startTime = new Date(year, month, 1).getTime()
      const endTime = new Date(year, month + 1, 0).getTime()
      return {
        startDate: formatDate('yyyy-MM-dd', new Date(startTime)),
        endDate: formatDate('yyyy-MM-dd', new Date(endTime))
      }
    },
    listenStartMonth () {
      this.$nextTick(() => {
        // 点击前一个月
        const startDateLeft = document.querySelector('.start-date .el-icon-arrow-left')
        startDateLeft.addEventListener('click', () => {
          const nowDate = this.getBeforeMonth(this.startMonth)
          this.startMonth = nowDate
          this.getDateToLoadPriceCalendar(nowDate)
        })
        // 点击后一个月
        const startDateRight = document.querySelector('.start-date .el-icon-arrow-right')
        startDateRight.addEventListener('click', () => {
          const nowDate = this.getNextMonth(this.startMonth)
          this.startMonth = nowDate
          this.getDateToLoadPriceCalendar(nowDate)
        })
      })
    },
    listenEndMonth () {
      this.$nextTick(() => {
        const endDateLeft = document.querySelector('.end-date .el-icon-arrow-left')
        endDateLeft.addEventListener('click', () => {
          const nowDate = this.getBeforeMonth(this.endMonth)
          this.endMonth = nowDate
          this.getDateToLoadPriceCalendar(nowDate)
        })
        const endDateRight = document.querySelector('.end-date .el-icon-arrow-right')
        endDateRight.addEventListener('click', () => {
          const nowDate = this.getNextMonth(this.endMonth)
          this.endMonth = nowDate
          this.getDateToLoadPriceCalendar(nowDate)
        })
      })
    },
    // 获取上一个月
    getBeforeMonth (date) {
      var now = new Date(date)
      var ds = new Date(now.setMonth(now.getMonth() - 1))
      var year = ds.getFullYear()
      var mon = ds.getMonth() + 1
      var day = ds.getDate()
      var s = year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day)
      return s
    },
    // 获取下一个月
    getNextMonth (date) {
      var now = new Date(date)
      var ds = new Date(now.setMonth(now.getMonth() + 1))
      var year = ds.getFullYear()
      var mon = ds.getMonth() + 1
      var day = ds.getDate()
      var s = year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day)
      return s
    }
  }
}
</script>
<style lang="scss">
.start-date .el-icon-d-arrow-left, .start-date .el-icon-d-arrow-right, .end-date .el-icon-d-arrow-left, .end-date .el-icon-d-arrow-right {
  display: none;
}
</style>
<style scoped lang='scss'>
.el-table--fit {
    border: 1px solid #3333}
.el-form-item {
     margin-bottom: 0px;}
     .el-form-item.is-error.is-required{
       margin-bottom: 22px;
     }
  .flex-start{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .flex-space-between{
    display: flex;
    justify-content:space-between;
    align-items: center;
  }

.packageTicket-book{
  background-color: #F5F6F9;
  overflow: hidden;

  .order-info{
    // max-width: 1279px;
    width: 1279px;
    overflow-x: auto;
    background: #FFFFFF;
    box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
    border-radius: 8px;
    box-sizing: border-box;
    margin: 0px auto;
    padding: 30px 40px 40px;
    .flex-align-start{
      display: flex;
      align-items: flex-start;
    }
    .title{
      font-size: 24px;
      font-weight: bold;
      color: #9B232A;
    }
    .subTitle{
      margin-top: 39px;
      margin-bottom: 28px;
      font-weight: bold;
      font-size: 20px;
      color: #242B34;
    }
      .order-info-item{
        .item-hd{
          margin-bottom: 14px;
       .order-info-item-span{
         margin-left: 8px;
         font-size: 16px;
         line-height: 21px;
         color: #183C50;
         font-weight: bold;
        }

       }
       .item-bd{
         .date-div{
          .num-div-item{
            text-align: center;
            border: 1px solid #95A3AF;
            border-radius: 4px;
            font-size: 16px;
            font-weight: bold;
            color: #44516F;
            display: inline-block;
            cursor: pointer;
            position: relative;
            img{
              width: 18px;
              height: 18px;
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }
           .active{
            border: 1px solid #9B232A;
            color:#1D263A
          }
          .other{
            background: #9B232A;
            font-size: 16px;
            color: #FFFFFF;
            /deep/.el-input__inner{
              border: none;
              background: unset;
              text-align: center;
              color: #fff;
              font-size: 16px;
            }
          }
         }
         .date-item-style{
            width: 203px;
           height: 42px;
           line-height: 42px;
         }
         .num-item-style{
            width: 102px;
           height: 42px;
           line-height: 42px;
         }
              .hide-date {
                position: absolute;
                z-index: -100;
                left: 0;
                top: 0;
              }

       }

        }
  }
  .buy-div{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 86px;
    span{
      font-size: 20px;
      font-weight: bold;
      color: #424855;
      margin-right: 2px;
    }
    .font12{
      font-weight: 400;
      font-size: 12px;
      color: #687280;
      margin-right: 10px;
    }
    .ml40{
      margin-left: 40px;
    }
    .price{
      color: #FF4400;
    }
    .buy-btn{
      width: 140px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #9B232A;
      opacity: 1;
      border-radius: 4px;
      font-size: 16px;
      font-weight: bold;
      color: #FFFFFF;
      margin-left: 30px;
      cursor: pointer;
    }
  }
}
.visitorMsg {
  background-color: #fff;
  margin-top: 20px;
}

.mt40{
  margin-top: 40px;
}
.headline {
  line-height: 46px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #424855;
  height: 46px;
}

.headline .sub {
  font-size: 16px;
  font-weight: bold;
}

.visitorMsg .msgForm {
  padding-top: 13px;
  padding-bottom: 13px;
  border-bottom: 1px solid #ccc;
}
.visitorMsg .msgForm:nth-last-child(1) {
  border-bottom: none;
}
.playTime{
  font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
line-height: 19px;
color: #737B8C;
  margin-top: 40px;
  margin-bottom:12px
}
.ml40{
margin-left: 40px;

}
.ticketsort {
  display:inline-block;
  padding: 40px 0 20px;
  font-size: 20px;
  font-weight: bold;
  line-height: 27px;
  color: #242B34;
}
</style>
